import {Button} from '@ui-kitten/components';
import React from 'react';
// import {StyleSheet} from 'react-native';
import LoadingIndicator from './LoadingIndicator';

const LoadingButton = ({children, onPress, loading, ...props}) => {
  return (
    <Button
      {...props}
      accessoryLeft={
        loading
          ? (evaProps) => (
              <LoadingIndicator
                status={props?.appearance !== 'outline' ? 'control' : 'primary'}
                {...evaProps}
              />
            )
          : undefined
      }
      onPress={(event) => {
        if (!loading && typeof onPress === 'function') {
          onPress(event);
        }
      }}>
      {children}
    </Button>
  );
};

// const styles = StyleSheet.create({});

export default LoadingButton;
